// @flow

import bemify from 'bemify-js';
import React, { type ElementRef } from 'react';
import { isEmpty } from 'lodash';

import AppsResults from 'app/service/components/AppsSearch/AppsResults';
import OutsideClickable from 'app/common/components/OutsideClickable';
import SearchBox from 'app/common/components/SearchBox';
import 'app/service/components/AppsSearch/AppsSearch.scss';

import { type App } from 'app/service/components/AppsSearch/types';

const bem = bemify('apps-search');

type Props = {
  apps: Array<App>,
  className: string,
  hoveredItem?: string,
  inputRef: ElementRef<any>,
  isLoading: boolean,
  onBlur: () => void,
  onChange: (value: string) => void,
  onFocus: () => void,
  onSelect: (value: string, didConfirm: boolean) => void,
  placeholder: string,
  searchText: string,
};

const EmptyApps = ({ isLoading }: { isLoading: boolean }) => (
  <div className={bem('__empty-apps-search-results')}>
    <div className={bem('__empty-apps-search-result')}>
      <span>{`${isLoading ? 'Loading' : 'No results'}...`}</span>
    </div>
  </div>
);

const AppsSearch = ({
  apps,
  className,
  hoveredItem,
  inputRef,
  isLoading,
  onChange,
  onBlur,
  onFocus,
  onSelect,
  placeholder,
  searchText,
}: Props) => (
  <OutsideClickable onClickOutside={onBlur}>
    <div className={bem(className)}>
      <SearchBox
        inputRef={inputRef}
        kind="minimalist"
        onChangeValue={query => onChange(query)}
        onClick={onFocus}
        onFocus={onFocus}
        onReset={onBlur}
        placeholder={placeholder}
        value={searchText}
      />
      {isEmpty(apps) || isLoading ? (
        !isEmpty(searchText) && <EmptyApps isLoading={isLoading} />
      ) : (
        <AppsResults
          hoveredItem={hoveredItem}
          items={apps}
          onChoose={onSelect}
        />
      )}
    </div>
  </OutsideClickable>
);

export default AppsSearch;
